import {
  SET_NAVIGATION_DRAWER_OPEN_REQUESTED,
  SET_NAVIGATION_DRAWER_OPEN_COMPLETED,
} from './types';

const setAction = async (isOpen) => async (dispatch) => {
  dispatch({
    type: SET_NAVIGATION_DRAWER_OPEN_REQUESTED,
  });
  return dispatch({
    type: SET_NAVIGATION_DRAWER_OPEN_COMPLETED,
    payload: isOpen,
  });
};

export default setAction;
